import * as inbox from "./inbox";
import * as oet from "./oet";
import * as master_budget from "./master_budget";
import * as dashboard_report from "./dashboard_report";

export default {
    inbox,
    oet,
    master_budget,
    dashboard_report,
};
